/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NormalAchievementType {
    PLAY_NUMBER_GAME = 'PLAY_NUMBER_GAME',
    COMMENT_NUMBER_GAME = 'COMMENT_NUMBER_GAME',
    ENDING_SEEKER = 'ENDING_SEEKER',
    PUBLISH_STORY = 'PUBLISH_STORY',
    REACH_VIEWS = 'REACH_VIEWS',
    REACH_NUMBER_5STAR_VOTE = 'REACH_NUMBER_5STAR_VOTE',
}
